import { ValueOfKey } from '../../../utils-types';

// should be the same as the event keys in app.config.js
export const ANGULAR_EVENT_KEYS = {
  INIT_USER_INFO_FINISHED: 'INIT_USER_INFO_FINISHED',
  UPDATE_USER: 'updateUser',
  ACTIVE_SOLUTION_CHANGED: 'ACTIVE_SOLUTION_CHANGED',
} as const;

export type AngularEventKeys = ValueOfKey<typeof ANGULAR_EVENT_KEYS>;
